var _module_exports = "<span>Settings were updated.</span>";;
var path = 'views/flashes/settings_updated.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;